// client/language-picker/flag-helper.ts
import "@adornis/base/utilTypes";
import { getLanguage, getCountries, getCountry } from "@hotosm/iso-countries-languages";
function getFlagByLangAbbreviation(lang) {
  return `https://flagcdn.com/${lang}.svg`;
}
async function getFlagByCountry(country) {
  const res = await fetch(`https://restcountries.com/v3.1/name/${country}?fields=flags`);
  const jsonRes = await res.json();
  return jsonRes[0].flags.svg;
}
async function getAllCountries(lang = "en") {
  return getCountries(lang);
}
function getCountryByCode(langCode, lang) {
  if (!langCode)
    return "";
  return getCountry(lang, langCode);
}
async function getFlagByCode(langCode) {
  try {
    const res = await fetch(`https://restcountries.com/v3.1/alpha/${langCode}?fields=flags`);
    const jsonRes = await res.json();
    return jsonRes.flags.svg;
  } catch (error) {
    return "";
  }
}
async function getAllFlags() {
  const countries = await getAllCountries("en");
  const res = await Promise.all(Object.entries(countries).map(([key, value]) => getFlagByCode(key)));
  return res;
}
async function getTranslatedLanguages(lang, selectedLanguages, toOriginal) {
  let langTranslationObj = {};
  if (toOriginal) {
    selectedLanguages.forEach((langOption) => {
      langTranslationObj[langOption] = getLanguage(langOption, langOption);
    });
  } else {
    selectedLanguages.forEach((langOption) => {
      langTranslationObj[langOption] = getLanguage(lang, langOption);
    });
  }
  return langTranslationObj;
}
export {
  getAllCountries,
  getAllFlags,
  getCountryByCode,
  getFlagByCode,
  getFlagByCountry,
  getFlagByLangAbbreviation,
  getTranslatedLanguages
};
